export const washU = {
  type: "Feature",
  properties: {},
  geometry: {
    type: "Point",
    coordinates: [
      -90.262866,
      38.635106,
      {
        city: "Washington University in St. Louis",
        state: "Missouri",
      },
    ],
  },
};

export const large = [
  {
    type: "Feature",
    properties: { featureIndex: 20, distanceToPoint: 5.055371102178251 },
    geometry: {
      type: "Point",
      coordinates: [
        -79.9958864,
        40.44062479999999,
        { city: "Pittsburgh", state: "Pennsylvania" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 0, distanceToPoint: 83.7110142664199 },
    geometry: {
      type: "Point",
      coordinates: [
        -122.4194155,
        37.7749295,
        { city: "Metro San Francisco", state: "California" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 1, distanceToPoint: 12.04870256297563 },
    geometry: {
      type: "Point",
      coordinates: [
        -77.0368707,
        38.9071923,
        { city: "Washington", state: "District of Columbia" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 2, distanceToPoint: 15.376454034076128 },
    geometry: {
      type: "Point",
      coordinates: [
        -94.5785667,
        39.0997265,
        { city: "Kansas City", state: "Missouri" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 4, distanceToPoint: 20.488154541238245 },
    geometry: {
      type: "Point",
      coordinates: [
        -90.5770675,
        38.6631083,
        { city: "Metro St. Louis", state: "Missouri" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 5, distanceToPoint: 3.2662084524956323 },
    geometry: {
      type: "Point",
      coordinates: [
        -75.1652215,
        39.9525839,
        { city: "Metro Philadelphia", state: "Pennsylvania" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 6, distanceToPoint: 15.074109525104241 },
    geometry: {
      type: "Point",
      coordinates: [
        -84.3879824,
        33.7489954,
        { city: "Metro Atlanta", state: "Georgia" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 9, distanceToPoint: 57.47935259725741 },
    geometry: {
      type: "Point",
      coordinates: [
        -83.0457538,
        42.331427,
        { city: "Metro Detroit", state: "Michigan" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 10, distanceToPoint: 3.0154460531249927 },
    geometry: {
      type: "Point",
      coordinates: [
        -104.990251,
        39.7392358,
        { city: "Metro Denver", state: "Colorado" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 11, distanceToPoint: 28.168696848795967 },
    geometry: {
      type: "Point",
      coordinates: [
        -96.79698789999999,
        32.7766642,
        { city: "Metro Dallas", state: "Texas" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 13, distanceToPoint: 37.5469448781822 },
    geometry: {
      type: "Point",
      coordinates: [
        -87.6297982,
        41.8781136,
        { city: "Metro Chicago", state: "Illinois" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 15, distanceToPoint: 16.11415023511703 },
    geometry: {
      type: "Point",
      coordinates: [
        -122.3320708,
        47.6062095,
        { city: "Metro Seattle", state: "Washington" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 17, distanceToPoint: 9.884031835901435 },
    geometry: {
      type: "Point",
      coordinates: [
        -81.3792365,
        28.5383355,
        { city: "Metro Orlando", state: "Florida" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 19, distanceToPoint: 56.22494545297156 },
    geometry: {
      type: "Point",
      coordinates: [
        -74.0059413,
        40.7127837,
        { city: "New York", state: "New York" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 20, distanceToPoint: 12.365190038780723 },
    geometry: {
      type: "Point",
      coordinates: [
        -119.7725868,
        36.7468422,
        { city: "Fresno", state: "California" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 21, distanceToPoint: 2.5542716781628805 },
    geometry: {
      type: "Point",
      coordinates: [
        -93.2650108,
        44.977753,
        { city: "Minneapolis", state: "Minnesota" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 23, distanceToPoint: 40.7417621567312 },
    geometry: {
      type: "Point",
      coordinates: [
        -92.28959479999999,
        34.7464809,
        { city: "Little Rock", state: "Arkansas" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 24, distanceToPoint: 10.407562046971277 },
    geometry: {
      type: "Point",
      coordinates: [
        -111.8910474,
        40.7607793,
        { city: "Salt Lake City", state: "Utah" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 25, distanceToPoint: 16.750926909799453 },
    geometry: {
      type: "Point",
      coordinates: [
        -117.1610838,
        32.715738,
        { city: "Metro San Diego", state: "California" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 31, distanceToPoint: 1.8494398174825555 },
    geometry: {
      type: "Point",
      coordinates: [
        -79.93105120000001,
        32.7764749,
        { city: "Charleston", state: "South Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 32, distanceToPoint: 11.377923886733118 },
    geometry: {
      type: "Point",
      coordinates: [
        -93.6091064,
        41.6005448,
        { city: "Metro Des Moines", state: "Iowa" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 34, distanceToPoint: 33.315107748631966 },
    geometry: {
      type: "Point",
      coordinates: [
        -118.2436849,
        34.0522342,
        { city: "Metro Los Angeles", state: "California" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 39, distanceToPoint: 9.979841077250887 },
    geometry: {
      type: "Point",
      coordinates: [
        -110.926479,
        32.2217429,
        { city: "Tucson", state: "Arizona" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 40, distanceToPoint: 69.29861828476905 },
    geometry: {
      type: "Point",
      coordinates: [
        -82.99879419999999,
        39.9611755,
        { city: "Columbus", state: "Ohio" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 46, distanceToPoint: 6.9499806738376595 },
    geometry: {
      type: "Point",
      coordinates: [
        -95.3698028,
        29.7604267,
        { city: "Metro Houston", state: "Texas" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 52, distanceToPoint: 13.009291171484536 },
    geometry: {
      type: "Point",
      coordinates: [
        -76.6121893,
        39.2903848,
        { city: "Metro Baltimore", state: "Maryland" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 56, distanceToPoint: 64.47941811589064 },
    geometry: {
      type: "Point",
      coordinates: [
        -121.4943996,
        38.5815719,
        { city: "Sacramento", state: "California" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 60, distanceToPoint: 9.634620662463295 },
    geometry: {
      type: "Point",
      coordinates: [
        -98.23001239999999,
        26.2034071,
        { city: "McAllen", state: "Texas" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 61, distanceToPoint: 20.359592422077174 },
    geometry: {
      type: "Point",
      coordinates: [
        -115.1398296,
        36.1699412,
        { city: "Metro Las Vegas", state: "Nevada" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 63, distanceToPoint: 2.5180226580218497 },
    geometry: {
      type: "Point",
      coordinates: [
        -97.7430608,
        30.267153,
        { city: "Metro Austin", state: "Texas" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 71, distanceToPoint: 20.91308428330905 },
    geometry: {
      type: "Point",
      coordinates: [
        -81.65565099999999,
        30.3321838,
        { city: "Jacksonville", state: "Florida" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 72, distanceToPoint: 7.2105243885503345 },
    geometry: {
      type: "Point",
      coordinates: [
        -112.0740373,
        33.4483771,
        { city: "Metro Phoenix", state: "Arizona" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 86, distanceToPoint: 74.63941996339527 },
    geometry: {
      type: "Point",
      coordinates: [
        -122.6764816,
        45.5230622,
        { city: "Metro Portland", state: "Oregon" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 94, distanceToPoint: 3.8794200857171557 },
    geometry: {
      type: "Point",
      coordinates: [
        -71.0588801,
        42.3600825,
        { city: "Metro Boston", state: "Massachusetts" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 101, distanceToPoint: 0.08078718382719426 },
    geometry: {
      type: "Point",
      coordinates: [
        -72.9278835,
        41.308274,
        { city: "New Haven", state: "Connecticut" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 103, distanceToPoint: 11.02551573356685 },
    geometry: {
      type: "Point",
      coordinates: [
        -87.9064736,
        43.0389025,
        { city: "Metro Milwaukee", state: "Wisconsin" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 105, distanceToPoint: 0.00019903368771297282 },
    geometry: {
      type: "Point",
      coordinates: [
        -90.19940419999999,
        38.6270025,
        { city: "St. Louis", state: "Missouri" },
      ],
    },
  },
];
